import React, { useState, useEffect } from 'react';

import { Container, Header, Title, Text, Button, Icon, Footer, Left, Body, Right, Spinner, FooterTab } from 'native-base';
import { StyleSheet, Platform, Linking, WebView, PermissionsAndroid } from 'react-native';
import HamburgerMenu from '../../components/hamburgerMenu';
import CalCalDataApi from '../../api/CalCalDataApi';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import PrevTaxYearBox from './prevTaxYearBox';

export default function TaxYearList({ navigation, route }) {
	const { jwt } = useSelector(
		state => ({
			jwt: state.loginReducer.jwt && state.loginReducer.jwt.token
		}),
		shallowEqual
	);

	const [fetching, setFetching] = useState(false);
	const [prevYears, setPrevYears] = useState();

	const getList = navToFirst => {
		if (!fetching) {
			setFetching(true);
			CalCalDataApi.dataLoad('reports/TaxPrevYears', jwt, res => {
				setFetching(false);
				if (!res.error) {
					if (navToFirst && res.prevYears && res.prevYears.length == 1 && res.prevYears[0].submittable) {
						navigation.isFocused() && navigation.navigate('SaDetails', { year: res.prevYears[0].taxyear });
					}
					setPrevYears(res.prevYears);
				} else {
					//something with the error!
				}
			});
		}
	};

	useEffect(() => {
		getList(true);
	}, []);

	useEffect(() => {
		const unsubscribe = navigation.addListener('focus', () => {
			getList(false);
		});

		return unsubscribe;
	}, [navigation]);
	//console.log(prevYears);
	return (
		<Container>
			<Header>
				<Left>
					<HamburgerMenu />
				</Left>
				<Body style={{ flex: 3 }}>
					<Title>Tax Return Years</Title>
				</Body>
				<Right />
			</Header>
			{!!prevYears && prevYears.map((y, i) => <PrevTaxYearBox key={i} year={y} navigation={navigation} taxOnly />)}
		</Container>
	);
}
